import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
import { renderBenefitText } from '../BenefitItem/renderBenefitText.js';
export const TabularBenefitsList = JSX(({ className, benefits }) => benefits?.length ? (_jsx("div", { className: style('grid grid-cols-[max-content_1fr] auto-rows-auto items-baseline gap-x-m gap-y-xs', className), role: "list", children: benefits.flatMap(renderBenefitText) })) : null);
//# sourceMappingURL=TabularBenefitsList.js.map